import OriginMenu from './menu.vue';
import OriginItem from './item.vue';
import OriginDivider from './divider.vue';
OriginMenu.Item = OriginItem;
OriginMenu.Divider = OriginDivider;
export default OriginMenu as typeof OriginMenu & {
  readonly Item: typeof OriginItem;
  readonly Divider: typeof OriginDivider;
};
